export const findSelectedSteps = (steps, selectedSteps) => {
  for (const step of steps) {
    const stepOptions = (
      step.fields.find(({ name }) => name === "step_count") || {}
    ).options;

    if (!stepOptions) {
      continue;
    }

    return (stepOptions.find(({ value }) => value === selectedSteps) || {})
      .steps;
  }
};

export const getLocales = (values, variants) => {
  if (values?.locales.length > 0) {
    // filter prismic locale select options by eagle availability
    const availableEagleLocales = variants?.map(
      (variant) => variant.options.locale
    );
    const locales = values.locales.filter((prismicLocale) =>
      availableEagleLocales.includes(prismicLocale.value)
    );
    return { locales, localeLabel: values.localeLabel };
  }
  return { locales: [] };
};
